import React, { Fragment } from 'react';
import { Stack, Text, Box } from '@solvhealth/jigsaw';
import List from '@material-ui/core/List';
import styled from 'styled-components';
import DrawerAction from './DrawerAction';

const ActionList = styled(List)`
  margin: 0;
  padding: 0;
`;

type Props = {
  actionsList: any[];
  title?: string;
  children?: any;
};

const DrawerTile = (props: Props) => {
  const { actionsList, title, children } = props;

  return (
    <>
      {title && (
        <Stack alignItems="center" justifyContent="flex-start" p={3} paddingBottom={0} row>
          <Text variant="h3">{title}</Text>
        </Stack>
      )}
      <ActionList>
        {actionsList.map((action, i) => (
          <Fragment key={action.actionText}>
            <DrawerAction
              actionText={action.actionText}
              icon={action.icon}
              isTextLink={action.isTextLink}
              onClick={action.onClick}
              showArrow={action.showArrow}
            />
            {i !== actionsList?.length - 1 && (
              <Box border="solid 1px" borderColor="gray-100" marginLeft={3} />
            )}
          </Fragment>
        ))}
      </ActionList>
      {children}
    </>
  );
};

export default DrawerTile;
